<template>
  <div>
    <w-datepicker class="form-group" :model="schema.date" />

    <div v-if="!showRecipients">
      <button class="btn btn-primary mt-2" @click="showRecipients = true">
        Pokaż odbiorców ({{ recipientsCount }})
      </button>
    </div>

    <div v-else>
      <div>Odbiorcy:</div>

      <div v-for="(item, index) in schema.recipients.$items" :key="index + '.recipient'">
        Id: {{ item.$item.documentId.$model }}
        <recipient :model="item.$item" :index="index" />
      </div>
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import Recipient from './components/Recipient';

// @vuese
// Formularz pisma bieżącej wypłaty w widoku wielu dokumentów
// @group ActionData
export default {
  components: { ...components, Recipient },
  props: {
    // schema
    schema: { type: Object, required: true }
  },
  data() {
    return { showRecipients: false };
  },
  computed: {
    recipientsCount() {
      return this.schema.recipients.$items.length;
    }
  }
};
</script>
